import React, {useState, useImperativeHandle, forwardRef, useMemo} from 'react';

import 'jodit';
import 'jodit/build/jodit.min.css';
import JoditEditor from "jodit-react";


type Props = {
  text: string;
  onChange:(string)=>void | null //TODO use this method instead of get value function by ref
};




function TextEditor(props: Props, ref) {
  const {text, onChange, disabled} = props;
  const [value, setValue] = useState(text ? text : "");
  
  const config = useMemo(() => (
    {
      readonly: disabled,
      direction: 'rtl',
      placeholder:"",
      removeButtons : [
        'source',
        '|',
        'strikethrough',
        'underline',
        '|',
        'superscript',
        'subscript',
        '|',
        'outdent',
        'indent',
        '|',
        'brush',
        'paragraph',
        '|',
        'image',
        'file',
        'video',
        'table',
        '|',
        '\n',
        'cut',
        'hr',
        'eraser',
        'copyformat',
        '|',
        'symbol',
        'fullsize',
        'selectall',
        'print',
        'about',
        'dots'
      ],
      buttons: ["bold", "italic", "|", "ul", "ol"],
      toolbarButtonSize : 'small',
    }
  ), [])
  
  const handleChange = (newValue) => {
    setValue(newValue);
    onChange && onChange(newValue);
  };
  
  useImperativeHandle(ref, () => ({
    value: value
  }));
  
  return(
    <JoditEditor
      value={value}
      config={config}
      onChange={handleChange}
    />
  )
  
}

export default forwardRef(TextEditor);